/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import logo from '../images/logo.png';
import FB from '../images/fb.svg';
import TW from '../images/tw.svg';

function Footer(props) {
    return (
        <>
        <footer>
            <div className="l">
                <a href="https://meneds.com">
                   <img src={logo} alt="MeNeds Branding"/>
                </a>
            </div>
            <div className="m">
                © 2022 Me-N-Ed’s. All rights reserved. Designed by JSA
            </div>
            <div className="r">
                <span>Follow us</span>
                <a href="https://www.facebook.com/menedspizzeria" target="_blank">
                    <img src={FB} alt="Facebook Link"/>
                </a>
                <a href="https://twitter.com/menedspizzeria" target="_blank">
                    <img src={TW} alt="Twitter Link"/>
                </a>
            </div>
        </footer>
        </>
    );
}

export default Footer;